import type { ResponseReadAll } from "epsm-api-types";
import { Converter } from "epsm-api-types/converter";
import {
	type PriceDailyRaw,
	type PriceDailyRawDTO,
	PriceDailyRawTypes,
	type RMRDTO,
} from "epsm-api-types/models";
import { BaseService } from "@/services/BaseService";
import { HttpClient, type IHttpClient } from "@/services/HttpClient";
import type { IReadAllParams } from "@/services/RequestParams";

export class SectorsService extends BaseService<
	PriceDailyRaw,
	PriceDailyRawDTO
> {
	private constructor(private httpClient: IHttpClient) {
		super(new Converter(PriceDailyRawTypes));
	}

	private static instance: SectorsService;

	static create() {
		if (!SectorsService.instance) {
			SectorsService.instance = new SectorsService(HttpClient.create());
		}

		return SectorsService.instance;
	}

	getPrices = async (options: {
		params: Readonly<IReadAllParams>;
		path: string;
		signal?: AbortSignal;
	}): Promise<ResponseReadAll<PriceDailyRawDTO>> => {
		const response = await this.httpClient.get<
			ResponseReadAll<PriceDailyRawDTO>
		>(`/prices/${options.path}`, {
			params: this.getQueryParams(options.params),
			signal: options.signal,
		});

		return response.data;
	};

	getRatio = async (options: {
		params: Readonly<IReadAllParams>;
		signal?: AbortSignal;
	}): Promise<ResponseReadAll<RMRDTO>> => {
		const response = await this.httpClient.get<ResponseReadAll<RMRDTO>>("rmr", {
			params: this.getQueryParams(options.params),
			signal: options.signal,
		});

		return response.data;
	};
}
